const AssuntoAtendimentoEnum = Object.freeze({
  DUVIDAS_SOFTWARE: 'Dúvidas sobre software',
  DUVIDAS_EQUIPAMENTOS: 'Dúvidas sobre equipamentos',
  SOLICITACAO_ESQUEMAS_ELETRICOS: 'Solicitação de esquemas elétricos',
  PROBLEMAS_DIESEL: 'Problemas com veículos - linha diesel',
  PROBLEMAS_LINHA_LEVE: 'Problemas com veículos - linha leve',
  EQUIPAMENTOS_MBB : 'Equipamentos MBB'
});

export default AssuntoAtendimentoEnum;
